// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.global-settings {
  padding: 2rem;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}
.global-settings h1 {
  text-align: center;
  margin-bottom: 2rem;
  font-size: 2rem;
  font-weight: 800;
  background-color: var(--primary-color);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: -0.025em;
}
.global-settings h1::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(135deg, #1e293b 0%, var(--primary-color) 50%, var(--primary-color) 100%);
  border-radius: 2px;
}
.global-settings .settings-tabs {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  background: white;
  padding: 0.5rem;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}
.global-settings .settings-tabs::-webkit-scrollbar {
  height: 4px;
}
.global-settings .settings-tabs::-webkit-scrollbar-track {
  background: transparent;
}
.global-settings .settings-tabs::-webkit-scrollbar-thumb {
  background: rgba(100, 116, 139, 0.3);
  border-radius: 2px;
}
.global-settings .settings-tabs::-webkit-scrollbar-thumb:hover {
  background: rgba(100, 116, 139, 0.5);
}
.global-settings .settings-tabs button {
  padding: 0.75rem 1.25rem;
  border: none;
  background: transparent;
  color: #64748b;
  font-weight: 500;
  font-size: 0.95rem;
  border-radius: 0;
  cursor: pointer;
  transition: color 0.2s ease;
  position: relative;
}
.global-settings .settings-tabs button:hover {
  color: #1e293b;
}
.global-settings .settings-tabs button.active {
  color: #1e293b;
  font-weight: 600;
}
.global-settings .settings-tabs button.active::after {
  content: "";
  position: absolute;
  bottom: 6px;
  left: 0;
  right: 0;
  margin: auto;
  width: 50%;
  height: 2px;
  background: var(--primary-color, #667eea);
  border-radius: 1px;
}
.global-settings .settings-section {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}
@media (max-width: 768px) {
  .global-settings {
    padding: 1rem;
  }
  .global-settings h2 {
    font-size: 2rem;
  }
  .global-settings .settings-tabs {
    gap: 0.25rem;
  }
  .global-settings .settings-tabs button {
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
  }
  .global-settings .settings-section {
    padding: 1.5rem;
  }
}
@media (max-width: 480px) {
  .global-settings .settings-tabs {
    flex-direction: column;
  }
  .global-settings .settings-tabs button {
    width: 100%;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/GlobalSettingsPage/GlobalSettingsPage.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,6DAAA;AACF;AACE;EAYE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,sCAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;EACA,wBAAA;AAVJ;AAYI;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,oGAAA;EAMA,kBAAA;AAfN;AAmBE;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,0CAAA;EACA,2BAAA;EAEA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAlBJ;AAqBI;EACE,WAAA;AAnBN;AAsBI;EACE,uBAAA;AApBN;AAuBI;EACE,oCAAA;EACA,kBAAA;AArBN;AAwBI;EACE,oCAAA;AAtBN;AAyBI;EACE,wBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;AAvBN;AAyBM;EACE,cAAA;AAvBR;AA0BM;EACE,cAAA;EACA,gBAAA;AAxBR;AA0BQ;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,yCAAA;EACA,kBAAA;AAxBV;AA8BE;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,0CAAA;EACA,0CAAA;EAGA,gBAAA;AA9BJ;AAgCE;EA3HF;IA4HI,aAAA;EA7BF;EA+BE;IACE,eAAA;EA7BJ;EAgCE;IACE,YAAA;EA9BJ;EAgCI;IACE,qBAAA;IACA,mBAAA;EA9BN;EAkCE;IACE,eAAA;EAhCJ;AACF;AAmCE;EACE;IACE,sBAAA;EAjCJ;EAmCI;IACE,WAAA;IACA,kBAAA;EAjCN;AACF","sourcesContent":[".global-settings {\r\n  padding: 2rem;\r\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\r\n\r\n  h1 {\r\n    // font-size: 2.5rem;\r\n    // font-weight: 800;\r\n    // color: #1e293b;\r\n    // margin-bottom: 2rem;\r\n    // text-align: center;\r\n    // background: linear-gradient(135deg, #1e293b 0%, var(--primary-color) 50%, var(--primary-color) 100%);\r\n    // -webkit-background-clip: text;\r\n    // -webkit-text-fill-color: transparent;\r\n    // background-clip: text;\r\n    // position: relative;\r\n\r\n    text-align: center;\r\n    margin-bottom: 2rem;\r\n    font-size: 2rem;\r\n    font-weight: 800;\r\n    background-color: var(--primary-color);\r\n    background-clip: text;\r\n    -webkit-background-clip: text;\r\n    -webkit-text-fill-color: transparent;\r\n    letter-spacing: -0.025em;\r\n\r\n    &::after {\r\n      content: \"\";\r\n      position: absolute;\r\n      bottom: -10px;\r\n      left: 50%;\r\n      transform: translateX(-50%);\r\n      width: 80px;\r\n      height: 4px;\r\n      background: linear-gradient(\r\n        135deg,\r\n        #1e293b 0%,\r\n        var(--primary-color) 50%,\r\n        var(--primary-color) 100%\r\n      );\r\n      border-radius: 2px;\r\n    }\r\n  }\r\n\r\n  .settings-tabs {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 0.5rem;\r\n    margin-bottom: 1rem;\r\n    background: white;\r\n    padding: 0.5rem;\r\n    border-radius: 8px;\r\n    border: 1px solid rgba(255, 255, 255, 0.2);\r\n    backdrop-filter: blur(10px);\r\n    // flex-wrap: wrap;\r\n    flex-wrap: nowrap; // Changed from wrap to nowrap\r\n    overflow-x: auto; // Add horizontal scroll\r\n    overflow-y: hidden; // Hide vertical scroll\r\n\r\n    // Optional: Hide scrollbar for cleaner look (still scrollable)\r\n    &::-webkit-scrollbar {\r\n      height: 4px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-track {\r\n      background: transparent;\r\n    }\r\n\r\n    &::-webkit-scrollbar-thumb {\r\n      background: rgba(100, 116, 139, 0.3);\r\n      border-radius: 2px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-thumb:hover {\r\n      background: rgba(100, 116, 139, 0.5);\r\n    }\r\n\r\n    button {\r\n      padding: 0.75rem 1.25rem;\r\n      border: none;\r\n      background: transparent;\r\n      color: #64748b;\r\n      font-weight: 500;\r\n      font-size: 0.95rem;\r\n      border-radius: 0;\r\n      cursor: pointer;\r\n      transition: color 0.2s ease;\r\n      position: relative;\r\n\r\n      &:hover {\r\n        color: #1e293b;\r\n      }\r\n\r\n      &.active {\r\n        color: #1e293b;\r\n        font-weight: 600;\r\n\r\n        &::after {\r\n          content: \"\";\r\n          position: absolute;\r\n          bottom: 6px;\r\n          left: 0;\r\n          right: 0;\r\n          margin: auto;\r\n          width: 50%;\r\n          height: 2px;\r\n          background: var(--primary-color, #667eea);\r\n          border-radius: 1px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .settings-section {\r\n    background: white;\r\n    border-radius: 8px;\r\n    padding: 1.5rem;\r\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\r\n    border: 1px solid rgba(255, 255, 255, 0.2);\r\n    // backdrop-filter: blur(20px);\r\n    // position: relative;\r\n    overflow: hidden;\r\n  }\r\n  @media (max-width: 768px) {\r\n    padding: 1rem;\r\n\r\n    h2 {\r\n      font-size: 2rem;\r\n    }\r\n\r\n    .settings-tabs {\r\n      gap: 0.25rem;\r\n\r\n      button {\r\n        padding: 0.75rem 1rem;\r\n        font-size: 0.875rem;\r\n      }\r\n    }\r\n\r\n    .settings-section {\r\n      padding: 1.5rem;\r\n    }\r\n  }\r\n\r\n  @media (max-width: 480px) {\r\n    .settings-tabs {\r\n      flex-direction: column;\r\n\r\n      button {\r\n        width: 100%;\r\n        text-align: center;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
